module.exports = __webpack_public_path__ + "static/media/G1-31-Maya-Myron-cod62.25d50692.png";